import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  values: {
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingTop: 20,
  },
  scrollView: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  spaceHeader: {
    marginTop: 30,
  },
  paymentText: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 18,
    maxWidth: 200,
    alignSelf: 'center',
    color: Colors.GrayPallete.lightgrayThree,
  },
  boldText: {
    fontWeight: 'bold',
  },
  containerFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 50,
  },
  debts: {
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 19,
    color: 'black',
  },
  buttonFilter: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textFilter: {
    marginRight: 10,
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 14,
    color: Colors.RedPallete.red,
  },
  containerCard: {
    marginVertical: 30,
  },
  message: {
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 20,
    color: 'black',
    textAlign: 'center',
    marginTop: 10,
    fontFamily: 'TCCC-UnityText Bold',
  },
  paragraph: {
    fontSize: 10,
    fontWeight: '200',
    color: Colors.GrayPallete.lightgrayThree,
    textAlign: 'center',
    marginTop: 10,
    fontFamily: 'TCCC-UnityText Bold',
  },
  phone: {
    fontSize: 16,
    fontWeight: '400',
    color: Colors.GrayPallete.lightgrayThree,
    textAlign: 'center',
    marginTop: 10,
    fontFamily: 'TCCC-UnityText Bold',
  },
  containerQuestions: {
    padding: 15,
    marginBottom: 20,
    backgroundColor: 'white',
    color: 'black',
  },
  containerModal: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 20,
    backgroundColor: 'rgba(0,0,0,0.4)',
  },
  containerFilter2: {
    width: '95%',
    backgroundColor: 'white',
    alignSelf: 'center',
    borderRadius: 16,
    paddingVertical: 15,
    flexDirection: 'column',
    justifyContent: 'space-between',
    maxHeight: '80%',
    minHeight: 200,
  },
  containerButton: {
    paddingHorizontal: 45,
    marginTop: 20,
    alignItems: 'center',
  },
  imageStyle: {
    width: 250,
    height: 250,
    alignSelf: 'center',
  },
  
  // Novos estilos para as modais modernas
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20,
  },
  modalContainer: {
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 32,
    alignItems: 'center',
    maxWidth: 350,
    width: '100%',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 10,
    },
    shadowOpacity: 0.25,
    shadowRadius: 20,
    elevation: 10,
  },
  modalIconContainer: {
    borderRadius: 50,
    width: 80,
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 24,
  },
  modalIconContainerSuccess: {
    backgroundColor: Colors.GreenPallete.greenOne,
  },
  modalIconContainerError: {
    backgroundColor: Colors.RedPallete.red,
  },
  modalIconContainerExpired: {
    backgroundColor: '#FFA726',
  },
  modalIcon: {
    fontSize: 40,
    color: 'white',
    fontWeight: 'bold',
  },
  modalIconExpired: {
    fontSize: 35,
    color: 'white',
    fontWeight: 'bold',
  },
  modalTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 12,
    fontFamily: 'TCCC-UnityText Bold',
  },
  modalTitleSuccess: {
    color: Colors.GreenPallete.greenOne,
  },
  modalTitleError: {
    color: Colors.RedPallete.red,
  },
  modalTitleExpired: {
    color: '#FF8F00',
  },
  modalSubtitle: {
    fontSize: 16,
    color: '#666',
    textAlign: 'center',
    marginBottom: 8,
    fontFamily: 'TCCC-UnityText Regular',
  },
  modalDescription: {
    fontSize: 14,
    lineHeight: 20,
    color: '#888',
    textAlign: 'center',
    marginBottom: 32,
    fontFamily: 'TCCC-UnityText Regular',
  },
});